import { BitmapText, Container, Text, TextStyle } from 'pixi.js'
import gsap from 'gsap'
import { t } from '../domain/language/languageUtil'

export const createTapTipsObject = (textX: number, textY: number) => {
  const tapTipsObject = new Text()
  tapTipsObject.text = t('tap_to_continue')
  tapTipsObject.alpha = 0.2
  tapTipsObject.anchor.set(0.5)
  tapTipsObject.x = textX
  tapTipsObject.y = textY
  tapTipsObject.style = new TextStyle({
    fontSize: 48,
    fill: '#ffffff',
    align: 'center',
    fontWeight: 'bold',
  })
  return tapTipsObject
}

export const showTapToContinueText = (container: Container, textX = 540, textY = 1800): Text => {
  const continueText = createTapTipsObject(textX, textY)
  tapAnywhereAnimation(continueText)
  container.addChild(continueText)
  return continueText
}

export const tapAnywhereAnimation = (text: Text | BitmapText) => {
  const tl = gsap.timeline({
    repeat: Infinity, // 無限重複
    yoyo: true,
  })

  tl.fromTo(text,
    { alpha: 0.2 },
    {
      duration: 1,
      alpha: 1,
      ease: 'sine.inOut',
    },
  )
}
